(function(){
  var LEAD_URL = 'https://whatsapp.bigstudio.cl/agenda-lead';

  // Origen de la visita (utm, clic de anuncio o sitio que refirió) para la nota del lead.
  function origen(){
    try {
      var q = new URLSearchParams(location.search), p = [];
      ['utm_source','utm_medium','utm_campaign'].forEach(function(k){ if(q.get(k)) p.push(q.get(k)); });
      if(q.get('origen')) p.push('cta ' + q.get('origen'));
      if(q.get('gclid')) p.push('gclid');
      if(q.get('fbclid')) p.push('fbclid');
      var ref = document.referrer ? new URL(document.referrer).hostname : '';
      if(ref && ref.indexOf('bigstudio.cl') === -1) p.push('ref ' + ref);
      // Sin campaña en la URL de la agenda: usar el primer contacto de la visita.
      if(!q.get('utm_source') && !q.get('gclid') && !q.get('fbclid') && !(ref && ref.indexOf('bigstudio.cl') === -1)){
        var o1 = ''; try { o1 = sessionStorage.getItem('bs_origen1') || ''; } catch(err){}
        if(o1) p.push('llegó por ' + o1);
      }
      return p.join(' / ');
    } catch(err){ return ''; }
  }
  // Móvil chileno como +569XXXXXXXX para que Calendly lo reconozca al prellenar.
  function telCL(v){
    var d = String(v || '').replace(/\D/g, '');
    if(d.indexOf('56') === 0) d = d.slice(2);
    return /^9\d{8}$/.test(d) ? '+56' + d : String(v || '').trim();
  }
  // "Plan Light", "light" o "LIGHT" quedan como "light" para comparar.
  function normPlan(v){
    return String(v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/^plan[\s_-]+/, '').trim();
  }
  // Ruta que corresponde al botón de origen (soporte-plan-pro, publicidad-hero, migrar-jumpseller-...).
  function rutaDeOrigen(o){
    o = String(o || '').toLowerCase();
    if(!o) return '';
    if(/^soporte/.test(o)) return 'soporte';
    if(/^(facturacion|integracion)/.test(o)) return 'facturacion';
    if(/^publicidad/.test(o)) return 'publicidad';
    if(/^(migrar|rediseno)/.test(o)) return 'migracion';
    return 'tienda';
  }
  function ufTxt(uf){ return String(uf).replace('.', ','); }

  function init(root){
    var d = root.dataset;
    var IVA = 1 + (parseFloat(d.iva || '19') / 100);
    var UFFB = parseFloat(d.uffb || '39500');
    var WA = d.wa || '56932141504';
    var CAL = d.cal || '';
    var READY = d.ready || 'Ver disponibilidad y agendar';
    var LOCKED = d.locked || 'Confirma plan, presupuesto y datos';
    var CONFIRM = d.confirm || '';
    var NOTE = d.note || '';
    var STEP_PLAN = d.stepPlan || '';
    var fmt = new Intl.NumberFormat('es-CL', {style:'currency', currency:'CLP', maximumFractionDigits:0});
    var ufVal = UFFB, sel = null, ruta = null, salida = false;
    var rutas = root.querySelectorAll('.bs-agf__ruta');
    var plans = root.querySelectorAll('.bs-agf__plan');
    var preguntas = root.querySelectorAll('.bs-agf__q');
    var ufEl = root.querySelector('.bs-agf__price-uf');
    var clpEl = root.querySelector('.bs-agf__price-clp');
    var rowsEl = root.querySelector('.bs-agf__price-rows');
    var priceTextEl = root.querySelector('.bs-agf__price-text');
    var noteEl = root.querySelector('.bs-agf__price-note');
    var confirmTxt = root.querySelector('.js-confirm-txt');
    var stepPlanEl = root.querySelector('.js-step-plan');
    var plansBox = root.querySelector('.bs-agf__plans');
    var tiendaReq = root.querySelector('.js-tienda-req');
    var ok = root.querySelector('.js-ok');
    var cta = root.querySelector('.js-cta');
    var ctaTxt = root.querySelector('.js-cta-txt');
    var nombreEl = root.querySelector('.js-nombre');
    var emailEl = root.querySelector('.js-email');
    var tiendaEl = root.querySelector('.js-tienda');
    var LEAD = d.lead || LEAD_URL;
    var ultimo = null, firmaIniciada = '', agendadaEnviada = false;
    if(rutas.length) root.classList.add('js-rutas-on');

    function rutaKey(){ return ruta ? ruta.dataset.ruta : ''; }
    function enRuta(p){
      if(!ruta) return true;
      return (p.dataset.rutas || 'tienda,migracion').split(',').indexOf(rutaKey()) > -1;
    }
    function tiendaObligatoria(){ return !!(ruta && ruta.dataset.store); }
    function preguntasVisibles(){
      var out = [];
      preguntas.forEach(function(q){ if(!q.hidden) out.push(q); });
      return out;
    }

    function paint(){
      if(!sel || !sel.dataset || !sel.dataset.uf) return;
      var uf = parseFloat(sel.dataset.uf);
      var mes = sel.dataset.periodo === 'mensual' ? ' al mes' : '';
      var sm = document.createElement('small');
      sm.textContent = '+ IVA' + mes;
      ufEl.textContent = ufTxt(sel.dataset.uf) + ' UF ';
      ufEl.appendChild(sm);
      clpEl.textContent = '≈ ' + fmt.format(Math.round(uf * ufVal * IVA)) + mes;
    }
    function refresh(){
      var n = nombreEl.value.trim(), e = emailEl.value.trim();
      var faltan = false;
      preguntasVisibles().forEach(function(q){
        var s = q.querySelector('.js-q');
        if(q.dataset.required && s && !s.value) faltan = true;
      });
      if(tiendaObligatoria() && !(tiendaEl && tiendaEl.value.trim())) faltan = true;
      if(rutas.length && !ruta) faltan = true;
      // La salida elegante informa, pero nunca oculta ni bloquea el calendario: el lead queda marcado fuera de perfil.
      var v = sel && ok.checked && n && /.+@.+\..+/.test(e) && !faltan;
      cta.classList.toggle('is-on', !!v);
      ctaTxt.textContent = v ? READY : LOCKED;
      root.dataset.sel = sel && sel.dataset ? (sel.dataset.name || '') : '';
      return v;
    }
    fetch('https://mindicador.cl/api/uf').then(function(r){return r.json();}).then(function(j){
      if(j && j.serie && j.serie[0] && j.serie[0].valor){ ufVal = j.serie[0].valor; if(sel) paint(); }
    }).catch(function(){});

    function elegirPlan(b){
      plans.forEach(function(x){ x.classList.remove('is-sel'); });
      b.classList.add('is-sel'); sel = b; paint(); refresh();
    }
    plans.forEach(function(b){ b.addEventListener('click', function(){ elegirPlan(b); }); });

    // Salida elegante: si la respuesta elegida no calza, se muestra la alternativa y no se habilita el calendario.
    function revisarSalida(){
      salida = false;
      preguntasVisibles().forEach(function(q){
        var s = q.querySelector('.js-q'), box = q.querySelector('.bs-agf__salida');
        var activa = !!(q.dataset.salida && s && s.value === q.dataset.salida);
        if(box) box.hidden = !activa;
        if(activa) salida = true;
      });
    }
    preguntas.forEach(function(q){
      var s = q.querySelector('.js-q');
      if(s) s.addEventListener('change', function(){ revisarSalida(); refresh(); });
    });

    function elegirRuta(btn, planPreferido){
      ruta = btn;
      rutas.forEach(function(r){ var on = r === btn; r.classList.toggle('is-sel', on); r.setAttribute('aria-checked', on ? 'true' : 'false'); });
      root.classList.add('has-ruta');
      var visibles = [];
      plans.forEach(function(p){ var si = enRuta(p); p.hidden = !si; if(si) visibles.push(p); });
      preguntas.forEach(function(q){ q.hidden = q.dataset.ruta !== rutaKey(); });
      revisarSalida();
      if(stepPlanEl) stepPlanEl.textContent = btn.dataset.stepPlan || STEP_PLAN;
      if(confirmTxt) confirmTxt.textContent = btn.dataset.confirm || CONFIRM;
      if(noteEl) noteEl.textContent = btn.dataset.note || NOTE;
      if(tiendaReq) tiendaReq.hidden = !tiendaObligatoria();
      if(ok) ok.checked = false;
      plans.forEach(function(x){ x.classList.remove('is-sel'); });
      sel = null;
      if(visibles.length){
        if(plansBox) plansBox.hidden = false;
        if(rowsEl) rowsEl.hidden = false;
        if(priceTextEl) priceTextEl.hidden = true;
        ufEl.textContent = 'Elige un plan';
        clpEl.textContent = 'Según el plan que elijas';
        var pref = planPreferido && visibles.indexOf(planPreferido) > -1 ? planPreferido : visibles[0];
        elegirPlan(pref);
      } else {
        // Ruta sin planes (publicidad): se registra con su nombre y se muestra el texto de inversión.
        if(plansBox) plansBox.hidden = true;
        if(rowsEl) rowsEl.hidden = true;
        if(priceTextEl){ priceTextEl.textContent = btn.dataset.priceText || ''; priceTextEl.hidden = !btn.dataset.priceText; }
        sel = { dataset: { name: btn.dataset.planName || btn.querySelector('.bs-agf__ruta-title').textContent.trim(), uf: '', url: CAL, periodo: '' } };
        refresh();
      }
    }
    rutas.forEach(function(r){ r.addEventListener('click', function(){
      elegirRuta(r, null);
      // En celular, bajar hasta los planes para que no queden escondidos bajo las tarjetas.
      if(window.innerWidth < 760 && stepPlanEl){
        var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        stepPlanEl.parentNode.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'start' });
      }
    }); });

    if(ok) ok.addEventListener('change', refresh);
    [nombreEl, emailEl, tiendaEl].forEach(function(el){ if(el) el.addEventListener('input', refresh); });

    function detalle(){
      var partes = [];
      preguntasVisibles().forEach(function(q){
        var s = q.querySelector('.js-q');
        if(s && s.value) partes.push((s.dataset.label || '').replace(/[¿?]/g, '').trim() + ': ' + s.value);
      });
      if(salida) partes.unshift('Fuera de perfil');
      return partes.join(' · ');
    }
    function ctx(){
      var g = function(c){ var el = root.querySelector(c); return el ? el.value.trim() : ''; };
      var uf = sel && sel.dataset.uf ? sel.dataset.uf : '';
      var clp = uf ? fmt.format(Math.round(parseFloat(uf) * ufVal * IVA)) : '';
      return { nombre:g('.js-nombre'), email:g('.js-email'), wsp:g('.js-wsp'), tienda:g('.js-tienda'),
               cuando:g('.js-cuando'), plan: sel ? sel.dataset.name : '', uf:uf, clp:clp,
               url: sel && sel.dataset.url ? sel.dataset.url : CAL,
               ruta: rutaKey(), periodo: sel && sel.dataset.periodo === 'mensual' ? 'mensual' : '', detalle: detalle() };
    }
    // Lead a Clientes de Shopify, vía whatsapp.bigstudio.cl/agenda-lead.
    // text/plain = petición simple (sin preflight) y keepalive para que salga aunque cierren la pestaña.
    function enviar(estado, c, extra){
      if(!LEAD || !c || !c.email) return;
      var datos = { estado: estado, nombre: c.nombre, email: c.email, wsp: c.wsp, tienda: c.tienda, cuando: c.cuando,
                    plan: c.plan, uf: c.uf, clp: c.clp, confirmo: c.confirmo, origen: origen(),
                    ruta: c.ruta, periodo: c.periodo, detalle: c.detalle };
      if(extra){ for(var k in extra){ datos[k] = extra[k]; } }
      try {
        fetch(LEAD, { method:'POST', mode:'cors', credentials:'omit', keepalive:true,
          headers:{ 'Content-Type':'text/plain;charset=UTF-8' }, body: JSON.stringify(datos) }).catch(function(){});
      } catch(err){}
    }

    if(cta) cta.addEventListener('click', function(){
      if(!refresh()) return;
      var c = ctx();
      c.confirmo = !!(ok && ok.checked);
      ultimo = c; agendadaEnviada = false;
      // "iniciada": pidió agendar. Si vuelve a hacer clic con los mismos datos no se repite.
      var firma = [c.email, c.nombre, c.plan, c.wsp, c.tienda, c.cuando, c.ruta, c.detalle].join('|');
      if(firma !== firmaIniciada){ firmaIniciada = firma; enviar('iniciada', c); }
      var url = c.url + (c.url.indexOf('?') > -1 ? '&' : '?') + 'hide_gdpr_banner=1'
        + '&name=' + encodeURIComponent(c.nombre) + '&email=' + encodeURIComponent(c.email);
      // a1 = primera pregunta del evento en Calendly (hoy: teléfono). Se prellena con el WhatsApp.
      if(c.wsp) url += '&a1=' + encodeURIComponent(telCL(c.wsp));
      if(window.Calendly){ Calendly.initPopupWidget({url:url}); }
      else { window.open(url, '_blank', 'noopener'); }
    });

    // "agendada": Calendly confirmó la reserva. El servidor la verifica y pone el tag agendaron.
    window.addEventListener('message', function(e){
      if(e.origin !== 'https://calendly.com' || !e.data || e.data.event !== 'calendly.event_scheduled') return;
      if(!ultimo || agendadaEnviada) return;
      agendadaEnviada = true;
      var p = e.data.payload || {};
      enviar('agendada', ultimo, { invitee: p.invitee && p.invitee.uri });
    });

    root.querySelectorAll('.js-wa').forEach(function(wa){
      wa.addEventListener('click', function(e){
        e.preventDefault();
        var c = ctx();
        var m = (ruta && ruta.dataset.wa) ? ruta.dataset.wa : '¡Hola BigStudio! Estoy viendo los planes';
        if(c.plan && c.uf) m += ' (' + c.plan + ', ' + ufTxt(c.uf) + ' UF + IVA' + (c.periodo === 'mensual' ? ' al mes' : '') + ')';
        m += ' y quiero más info antes de agendar.';
        window.open('https://wa.me/' + WA + '?text=' + encodeURIComponent(m), '_blank', 'noopener');
      });
    });

    // Plan preseleccionado desde el anuncio o el botón: ?plan=light o utm_content=light.
    // En otras rutas calza por el final del nombre ("Soporte Pro" con ?plan=pro).
    function planDeUrl(lista){
      try {
        var q = new URLSearchParams(location.search);
        var v = normPlan(q.get('plan') || q.get('utm_content'));
        if(!v) return null;
        for(var i = 0; i < lista.length; i++){
          var n = normPlan(lista[i].dataset.name);
          if(n === v || n.slice(-(v.length + 1)) === ' ' + v) return lista[i];
        }
      } catch(err){}
      return null;
    }

    if(!rutas.length){
      // Sin rutas configuradas: comportamiento de siempre.
      if(plans.length){ (planDeUrl(plans) || plans[0]).click(); }
      return;
    }
    // Ruta inicial: ?ruta=, después el botón de origen (soporte-plan-pro manda sobre ?plan=pro)
    // y por último un ?plan= de tienda (anuncios). Sin pistas, la persona elige.
    var q0 = new URLSearchParams(location.search);
    var clave = (q0.get('ruta') || '').toLowerCase();
    if(!clave) clave = rutaDeOrigen(q0.get('origen'));
    if(!clave && (q0.get('plan') || q0.get('utm_content'))){
      var tiendaPlans = [];
      plans.forEach(function(p){ if((p.dataset.rutas || 'tienda,migracion').split(',').indexOf('tienda') > -1) tiendaPlans.push(p); });
      if(planDeUrl(tiendaPlans)) clave = 'tienda';
    }
    var inicial = null;
    rutas.forEach(function(r){ if(r.dataset.ruta === clave) inicial = r; });
    if(inicial){
      var lista = [];
      plans.forEach(function(p){ if((p.dataset.rutas || 'tienda,migracion').split(',').indexOf(clave) > -1) lista.push(p); });
      elegirRuta(inicial, planDeUrl(lista));
    } else {
      refresh();
    }
  }
  function go(){ document.querySelectorAll('.bs-agf').forEach(init); }
  if(document.readyState !== 'loading'){ go(); } else { document.addEventListener('DOMContentLoaded', go); }
})();

/* ============================================================
   BigStudio · Medición de la agenda en Meta y Google Ads
   (2026-09-11 · eventID y Google Ads el 2026-09-26)
   ------------------------------------------------------------
   Eventos de ESTA página:
     Lead       -> clic en el CTA ya desbloqueado (plan + presupuesto + datos)
     Schedule   -> Calendly confirmó la reserva. Va con eventID = id de la
                   reserva y deja la marca bs_sched_<id> en localStorage:
                   si después Calendly redirige a /pages/reunion-agendada,
                   esa página no vuelve a contar la misma agenda.
     Google Ads -> evento invitee_meeting_scheduled (AW-617482908, llega por
                   la etiqueta GT-T5PXHDLF) con transaction_id = id de la
                   reserva, así Google descarta la conversión si se repite.

   El clic a WhatsApp NO se mide aquí. Se mide en todo el sitio
   desde bs-agenda-redirect.js, para no contarlo dos veces.

   No disparamos PageView: de eso ya se encarga el canal de
   Shopify. El guard del snippet reutiliza el fbq que Shopify
   inyecta y solo lo crea si todavía no llegó.
   ============================================================ */
(function () {
  'use strict';

  var PIXEL_ID = '595968475232736';
  if (!document.querySelector('.bs-agf')) return;

  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
  (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');

  fbq('init', PIXEL_ID);

  function datosPlan() {
    var plan = document.querySelector('.bs-agf__plan.is-sel');
    var clpEl = document.querySelector('.bs-agf__price-clp');
    var clp = 0;
    if (clpEl) {
      var digitos = (clpEl.textContent || '').replace(/\D/g, '');
      if (digitos) clp = parseInt(digitos, 10);
    }
    var raiz = document.querySelector('.bs-agf');
    return {
      content_name: plan ? (plan.getAttribute('data-name') || '') : ((raiz && raiz.dataset.sel) || ''),
      content_category: 'Agenda',
      value: clp || 0,
      currency: 'CLP'
    };
  }

  /* Lead: clic en el CTA ya desbloqueado */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var cta = e.target.closest('.bs-agf .js-cta');
    if (!cta || !cta.classList.contains('is-on')) return;
    fbq('track', 'Lead', datosPlan());
  }, true);

  /* Schedule: Calendly confirmó la reserva */
  var yaReservo = false;
  window.addEventListener('message', function (e) {
    if (e.origin !== 'https://calendly.com') return;
    var data = e.data;
    if (!data || data.event !== 'calendly.event_scheduled') return;
    if (yaReservo) return;
    yaReservo = true;
    var p = data.payload || {};
    var id = ((p.invitee && p.invitee.uri) || '').split('/').pop();
    try { if (id) localStorage.setItem('bs_sched_' + id, String(Date.now())); } catch (err) {}
    var datos = datosPlan();
    if (id) { fbq('track', 'Schedule', datos, { eventID: id }); }
    else { fbq('track', 'Schedule', datos); }
    if (typeof window.gtag === 'function') {
      var g = { content_name: datos.content_name };
      if (id) g.transaction_id = id;
      if (datos.value) { g.value = datos.value; g.currency = 'CLP'; }
      window.gtag('event', 'invitee_meeting_scheduled', g);
    }
  });

})();
